import React, { createContext, useReducer, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        isAuthenticated: true,
        cif: action.payload.cif,
        nombre: action.payload.nombre,
        token: action.payload.token,
        status: action.payload.status,
      };
    case 'LOGOUT':
      return { isAuthenticated: false, cif: null, nombre: null, token: null, status: null };
    default:
      return state;
  }
};

const loadStateFromLocalStorage = () => {
  const storedState = localStorage.getItem('authState2025');
  return storedState ? JSON.parse(storedState) : { isAuthenticated: false, cif: null, nombre: null, token: null, status: null };
};

const AuthProvider = ({ children }) => {
    const [dispatch, setDispatch] = useReducer(authReducer, {}, loadStateFromLocalStorage);
  
    useEffect(() => {
      // Guardar el estado en localStorage cada vez que cambie
      localStorage.setItem('authState2025', JSON.stringify(dispatch));
    }, [dispatch]);
  
  
    return (
      <AuthContext.Provider value={{ dispatch, setDispatch }}>
        {children}
      </AuthContext.Provider>
    );
  };

const useAuth = () => {
  return useContext(AuthContext);
};

export { AuthProvider, useAuth };
